import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token = useSelector((state: RootState) => state.user.token);
  const isRehydrated = useSelector((state: any) => state._persist?.rehydrated);
  const location = useLocation();
  const { country } = useParams();

  if (!isRehydrated) return null;

  if (!token) {
    // Redirect to country-prefixed login if not authenticated
    return <Navigate to={`/${country}/login`} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 